import { Tag } from 'antd'

import { EpidemiologyCaseStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status: EpidemiologyCaseStatus
}

const ColorMap = {
  [EpidemiologyCaseStatus.DRAFT]: 'default',
  [EpidemiologyCaseStatus.NEW]: 'success',
  [EpidemiologyCaseStatus.SYNCHRONISED]: 'processing'
}

export const StatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  return (
    <Tag color={ColorMap[status]}>{t(`epidemiology.status.${status}`)}</Tag>
  )
}
